import React, { useEffect, useState, useMemo } from "react";
import { flattenCategories } from "../../utils/flattenCategories";
import { useProductCategory } from "./hooks/useProductCategory";
import { getImageUrl } from "utils/imageHelper";
import ImageViewer from "../common/ImageViewer";

export default function ProductCategoryForm({ initialData, onSubmit }) {
  const { categories, loadCategoriesByOrganizer } = useProductCategory();

  const companyId = localStorage.getItem("company_id");

  const [form, setForm] = useState({
    title: "",
    parent_id: "",
    image: null,
  });

  const [viewerOpen, setViewerOpen] = useState(false);


  useEffect(() => {
    if (companyId) {
      loadCategoriesByOrganizer(companyId);
    }
  }, [companyId]);


  useEffect(() => {
    if (initialData) {
      setForm({
        title: initialData.title || "",
        parent_id: initialData.parent_id?._id || "",
        image: initialData.image || null,
      });
    }
  }, [initialData]);

  const parentCategories = useMemo(
    () => flattenCategories(categories || []),
    [categories]
  );

  const submit = async (e) => {
    e.preventDefault();

    const payload = new FormData();
    payload.append("title", form.title);
    payload.append("company_id", companyId);
    payload.append("parent_id", form.parent_id || "");

    if (form.image && typeof form.image !== "string") {
      payload.append("image", form.image);
    }

    await onSubmit(payload);
  };

  const handleFile = (e) => {
    const file = e.target.files?.[0];
    if (file) {
      setForm((prev) => ({ ...prev, image: file }));
    }
  };

  return (
    <form onSubmit={submit} className="space-y-4">

      <div>
        <label className="mb-1 block text-sm font-medium">
          Parent Category
        </label>
        <select
          className="w-full rounded border p-2"
          value={form.parent_id}
          onChange={(e) =>
            setForm({ ...form, parent_id: e.target.value })
          }
        >
          <option value="">Parent Category (Optional)</option>
          {parentCategories.map((cat) => (
            <option key={cat._id} value={cat._id}>
              {cat.title}
            </option>
          ))}
        </select>
      </div>

      <div>
        <label className="mb-1 block text-sm font-medium">
          Category Title<span className="text-red-500">*</span>
        </label>
        <input
          className="w-full rounded border p-2"
          placeholder="Category Title"
          value={form.title}
          onChange={(e) =>
            setForm({ ...form, title: e.target.value })
          }
          required
        />
      </div>

      <div>
        <label className="mb-1 block text-sm font-medium">
          Image
          <span className="ml-2 text-xs font-normal text-gray-500">
            (Recommended resolution: 393 × 219 px. Accepted formats: JPEG, PNG. )
          </span>
        </label>

        <input
          type="file"
          accept="image/*"
          className="w-full rounded border p-2"
          onChange={handleFile}
        />

        {form.image && typeof form.image === "string" && (
          <>
            <img
              src={getImageUrl(form.image)}
              alt="Category"
              className="mt-2 h-24 cursor-pointer rounded border object-contain"
              onClick={() => setViewerOpen(true)}
            />
            <ImageViewer
              open={viewerOpen}
              onClose={() => setViewerOpen(false)}
              src={getImageUrl(form.image)}
            />
          </>
        )}
      </div>

      <button className="w-full rounded bg-blue-600 py-2 text-white">
        Save Category
      </button>
    </form>
  );
}
